import { render, staticRenderFns } from "./analysis_box.vue?vue&type=template&id=872c9d98"
import script from "./analysis_box.vue?vue&type=script&lang=js"
export * from "./analysis_box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports